module.exports = __webpack_public_path__ + "static/scale-model-of-shelter-gardens-in-columbia-missouri-395e3bbaa0a00983f868d1edc9385147.png";